// // pages/MyAccount.jsx
// import React, { useState, useEffect, useCallback } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { 
//   ArrowLeft, 
//   Camera, 
//   Mail, 
//   Phone, 
//   User, 
//   Shield, 
//   Bell, 
//   Globe,
//   Save,
//   Edit2
// } from 'lucide-react';
// import api from '../common/apiClient';
// import SummaryApi from '../common/SummaryApi';
// import { formatDateTime } from '../helpers/formatDateTime';
// import MyAccountSkeleton from '../components/SkeletonComponents/MyAccountSkeleton';

// const MyAccount = () => {
//   const [user, setUser] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [isEditing, setIsEditing] = useState(false);
//   const [editData, setEditData] = useState({});
//   const [activeTab, setActiveTab] = useState('profile');
//   const navigate = useNavigate();
//   const userData = localStorage.getItem('user');
//   const userId = JSON.parse(userData)?._id;

//   const fetchUserData = useCallback(async () => {
//     if (!userId) return;

//     setLoading(true);
//     try {
//       const response = await api.get(SummaryApi.viewOneUser.url(userId));
//       if (response.data.success) {
//         setUser(response.data.data);
//         setEditData(response.data.data);
//       }
//     } catch (error) {
//       console.error("Failed to fetch user:", error);
//     } finally {
//       setLoading(false);
//     }
//   }, [userId]);

//   useEffect(() => {
//     fetchUserData();
//   }, [fetchUserData]);

//   const handleImageUpload = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       // Handle image upload logic here
//       console.log('Uploading image:', file);
//     }
//   };

//   const getInitials = (firstName, lastName) => {
//     if (!firstName && !lastName) return 'U';
//     return `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase();
//   };

//   if (loading) {
//     return <MyAccountSkeleton />;
//   }

//   return (
//     <div className="min-h-screen bg-gray-50">
//       {/* Header */}
//       <div className="bg-white shadow-sm border-b sticky top-0 z-10">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="flex items-center justify-between h-16">
//             <div className="flex items-center">
//               <button
//                 onClick={() => navigate(-1)}
//                 className="mr-4 p-2 hover:bg-gray-100 rounded-lg transition-colors"
//               >
//                 <ArrowLeft className="w-5 h-5" />
//               </button>
//               <h1 className="text-xl font-semibold">My Account</h1>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Profile Header */}
//       <div className="bg-gradient-to-r from-red-600 to-red-600 pt-8 pb-32">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="text-center">
//             <div className="relative inline-block">
//               {user?.profilePicture ? (
//                 <img
//                   src={user.profilePicture}
//                   alt={`${user.firstName} ${user.lastName}`}
//                   className="w-32 h-32 rounded-full object-cover border-4 border-white shadow-xl"
//                 />
//               ) : (
//                 <div className="w-32 h-32 rounded-full bg-white flex items-center justify-center text-4xl font-bold text-gray-700 shadow-xl">
//                   {getInitials(user?.firstName, user?.lastName)}
//                 </div>
//               )}
//               <label className="absolute bottom-0 right-0 bg-white rounded-full p-2 shadow-lg cursor-pointer hover:bg-gray-100 transition-colors">
//                 <Camera className="w-5 h-5 text-gray-700" />
//                 <input
//                   type="file"
//                   className="hidden"
//                   accept="image/*"
//                   onChange={handleImageUpload}
//                 />
//               </label>
//             </div>
//             <h2 className="mt-4 text-2xl font-bold text-white">
//               {user?.firstName} {user?.lastName}
//             </h2>
//             <p className="text-red-100">{user?.email}</p>
//           </div>
//         </div>
//       </div>

//       {/* Content */}
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-20">
//         {/* Tabs */}
//         <div className="bg-white rounded-lg shadow-sm mb-6">
//           <div className="flex flex-wrap border-b">
//             {[
//               { id: 'profile', label: 'Profile', icon: User },
//               { id: 'security', label: 'Security', icon: Shield },
//               { id: 'notifications', label: 'Notifications', icon: Bell },
//               { id: 'preferences', label: 'Preferences', icon: Globe },
//             ].map((tab) => {
//               const Icon = tab.icon;
//               return (
//                 <button
//                   key={tab.id}
//                   onClick={() => setActiveTab(tab.id)}
//                   className={`flex-1 sm:flex-initial flex items-center justify-center space-x-2 px-6 py-4 border-b-2 transition-colors ${
//                     activeTab === tab.id
//                       ? 'border-red-500 text-red-600'
//                       : 'border-transparent text-gray-500 hover:text-gray-700'
//                   }`}
//                 >
//                   <Icon className="w-4 h-4" />
//                   <span className="hidden sm:inline">{tab.label}</span>
//                 </button>
//               );
//             })}
//           </div>
//         </div>

//         {/* Tab Content */}
//         <div className="bg-white rounded-lg shadow-sm p-6">
//           {activeTab === 'profile' && (
//             <div className="space-y-6">
//               <div className="flex items-center justify-between mb-6">
//                 <h3 className="text-lg font-semibold">Profile Information</h3>
//                 <button
//                   onClick={() => setIsEditing(!isEditing)}
//                   className="flex items-center space-x-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
//                 >
//                   {isEditing ? <Save className="w-4 h-4" /> : <Edit2 className="w-4 h-4" />}
//                   <span>{isEditing ? 'Save' : 'Edit'}</span>
//                 </button>
//               </div>

//               <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     First Name
//                   </label>
//                   <input
//                     type="text"
//                     value={editData.firstName || ''}
//                     onChange={(e) => setEditData({ ...editData, firstName: e.target.value })}
//                     disabled={!isEditing}
//                     className={`w-full px-4 py-2 border rounded-lg ${
//                       isEditing
//                         ? 'border-gray-300 focus:border-red-500 focus:ring-1 focus:ring-red-500'
//                         : 'border-gray-200 bg-gray-50'
//                     }`}
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Last Name
//                   </label>
//                   <input
//                     type="text"
//                     value={editData.lastName || ''}
//                     onChange={(e) => setEditData({ ...editData, lastName: e.target.value })}
//                     disabled={!isEditing}
//                     className={`w-full px-4 py-2 border rounded-lg ${
//                       isEditing
//                         ? 'border-gray-300 focus:border-red-500 focus:ring-1 focus:ring-red-500'
//                         : 'border-gray-200 bg-gray-50'
//                     }`}
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     <Mail className="inline w-4 h-4 mr-1" />
//                     Email
//                   </label>
//                   <input
//                     type="email"
//                     value={editData.email || ''}
//                     onChange={(e) => setEditData({ ...editData, email: e.target.value })}
//                     disabled={!isEditing}
//                     className={`w-full px-4 py-2 border rounded-lg ${
//                       isEditing
//                         ? 'border-gray-300 focus:border-red-500 focus:ring-1 focus:ring-red-500'
//                         : 'border-gray-200 bg-gray-50'
//                     }`}
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     <Phone className="inline w-4 h-4 mr-1" />
//                     Mobile
//                   </label>
//                   <input
//                     type="tel"
//                     value={editData.mobile || ''}
//                     onChange={(e) => setEditData({ ...editData, mobile: e.target.value })}
//                     disabled={!isEditing}
//                     className={`w-full px-4 py-2 border rounded-lg ${
//                       isEditing
//                         ? 'border-gray-300 focus:border-red-500 focus:ring-1 focus:ring-red-500'
//                         : 'border-gray-200 bg-gray-50'
//                     }`}
//                   />
//                 </div>
//               </div>
//             </div>
//           )}

//           {activeTab === 'security' && (
//             <div className="space-y-6">
//               <h3 className="text-lg font-semibold mb-4">Security Settings</h3>
//               <div className="space-y-4">
//                 <button className="w-full sm:w-auto px-6 py-3 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors">
//                   Change Password
//                 </button>
//                 <div className="p-4 bg-gray-50 rounded-lg">
//                   <p className="text-sm text-gray-600">
//                     Last password change: {new formatDateTime().toLocaleDateString()}
//                   </p>
//                 </div>
//               </div>
//             </div>
//           )}

//           {activeTab === 'notifications' && (
//             <div className="space-y-6">
//               <h3 className="text-lg font-semibold mb-4">Notification Preferences</h3>
//               <div className="space-y-4">
//                 {['Email Notifications', 'SMS Notifications', 'Push Notifications'].map((item) => (
//                   <label key={item} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg cursor-pointer hover:bg-gray-100">
//                     <span className="font-medium">{item}</span>
//                     <input type="checkbox" className="w-5 h-5 text-red-600 rounded focus:ring-red-500" />
//                   </label>
//                 ))}
//               </div>
//             </div>
//           )}

//           {activeTab === 'preferences' && (
//             <div className="space-y-6">
//               <h3 className="text-lg font-semibold mb-4">Preferences</h3>
//               <div className="space-y-4">
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Language
//                   </label>
//                   <select className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:border-red-500 focus:ring-1 focus:ring-red-500">
//                     <option>English</option>
//                     <option>Spanish</option>
//                     <option>French</option>
//                   </select>
//                 </div>
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Timezone
//                   </label>
//                   <select className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:border-red-500 focus:ring-1 focus:ring-red-500">
//                     <option>Asia/Kolkata</option>
//                     <option>America/New_York</option>
//                     <option>Europe/London</option>
//                   </select>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default MyAccount;

// // pages/MyAccount.jsx
// import React, { useState, useEffect, useCallback } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { 
//   ArrowLeft, 
//   Camera, 
//   Mail, 
//   Phone, 
//   User, 
//   Shield, 
//   Bell, 
//   Globe,
//   Edit2,
//   Loader,
//   Check,
//   X
// } from 'lucide-react';
// import api from '../common/apiClient';
// import SummaryApi from '../common/SummaryApi';
// import { formatDateTime } from '../helpers/formatDateTime';
// import { toast } from 'react-toastify';
// import { MyAccountSkeleton } from '../components/SkeletonComponents/MyAccountSkeleton';

// const MyAccount = () => {
//   const [user, setUser] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [isEditing, setIsEditing] = useState(false);
//   const [editData, setEditData] = useState({});
//   const [activeTab, setActiveTab] = useState('profile');
//   const [imageUploading, setImageUploading] = useState(false);
//   const [saveLoading, setSaveLoading] = useState(false);
//   const navigate = useNavigate();
  
//   const userData = localStorage.getItem('user');
//   const userId = JSON.parse(userData)?._id;

//   const fetchUserData = useCallback(async () => {
//     if (!userId) return;

//     setLoading(true);
//     try {
//       const response = await api.get(SummaryApi.viewOneUser.url(userId));
//       if (response.data.success) {
//         setUser(response.data.data);
//         setEditData(response.data.data);
//       }
//     } catch (error) {
//       console.error("Failed to fetch user:", error);
//       toast.error('Failed to load user data');
//     } finally {
//       setLoading(false);
//     }
//   }, [userId]);

//   useEffect(() => {
//     fetchUserData();
//   }, [fetchUserData]);

//   const handleImageUpload = async (e) => {
//     const file = e.target.files?.[0];
//     if (!file) return;

//     // Validate file type
//     const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
//     if (!validTypes.includes(file.type)) {
//       toast.error('Please upload a valid image file (JPG, PNG, or WebP)');
//       e.target.value = '';
//       return;
//     }

//     // Validate file size (5MB max)
//     if (file.size > 5 * 1024 * 1024) {
//       toast.error('Image size should be less than 5MB');
//       e.target.value = '';
//       return;
//     }

//     setImageUploading(true);
//     const formData = new FormData();
//     formData.append('profilePicture', file);

//     try {
//       const response = await api.put(SummaryApi.uploadUserPicture.url(userId), formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         },
//       });

//       if (response.data.success) {
//         toast.success('Profile picture updated successfully');
        
//         // Update user data with new picture
//         const updatedUser = response.data.user || {
//           ...user,
//           profilePicture: response.data.profilePicture
//         };
        
//         setUser(updatedUser);
//         setEditData(updatedUser);
        
//         // Update localStorage
//         const localUser = JSON.parse(localStorage.getItem('user') || '{}');
//         localStorage.setItem('user', JSON.stringify({
//           ...localUser,
//           profilePicture: updatedUser.profilePicture
//         }));
//       }
//     } catch (error) {
//       console.error("Error uploading profile picture:", error);
//       toast.error(error.response?.data?.message || 'Failed to upload image');
//     } finally {
//       setImageUploading(false);
//       e.target.value = '';
//     }
//   };

//   const handleSave = async () => {
//     setSaveLoading(true);
//     try {
//       const response = await api.put(SummaryApi.updateUser.url(userId), {
//         firstName: editData.firstName,
//         lastName: editData.lastName,
//         email: editData.email,
//         mobile: editData.mobile
//       });

//       if (response.data.success) {
//         const updatedUser = response.data.data || response.data.user;
//         setUser(updatedUser);
//         setEditData(updatedUser);
//         setIsEditing(false);
//         toast.success('Profile updated successfully');
        
//         // Update localStorage
//         const localUser = JSON.parse(localStorage.getItem('user') || '{}');
//         localStorage.setItem('user', JSON.stringify({
//           ...localUser,
//           ...updatedUser
//         }));
//       }
//     } catch (error) {
//       console.error("Error updating profile:", error);
//       toast.error(error.response?.data?.message || 'Failed to update profile');
//     } finally {
//       setSaveLoading(false);
//     }
//   };

//   const handleCancel = () => {
//     setIsEditing(false);
//     setEditData(user);
//   };

//   const getInitials = (firstName, lastName) => {
//     if (!firstName && !lastName) return 'U';
//     return `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase();
//   };

//   if (loading) {
//     return <MyAccountSkeleton />;
//   }

//   return (
//     <div className="">
//       {/* Header - Responsive */}
//       <div className="bg-white shadow-sm border-b sticky top-0 z-10">
//         <div className="mx-auto px-4">
//           <div className="flex items-center justify-between h-12">
//             <div className="flex items-center">
//               <button
//                 onClick={() => navigate(-1)}
//                 className="mr-2 sm:mr-4 p-2 hover:bg-gray-100 rounded-lg transition-colors"
//               >
//                 <ArrowLeft className="w-5 h-5" />
//               </button>
//               <h1 className="text-lg sm:text-xl font-semibold">My Account</h1>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Profile Header - Responsive */}
//       <div className="bg-gradient-to-r from-red-600 to-red-600 pt-6 sm:pt-8 pb-24 sm:pb-32">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="text-center">
//             <div className="relative inline-block">
//               {user?.profilePicture ? (
//                 <>
//                   <img
//                     src={user.profilePicture}
//                     alt={`${user.firstName} ${user.lastName}`}
//                     className="w-24 h-24 sm:w-32 sm:h-32 rounded-full object-cover border-4 border-white shadow-xl"
//                   />
//                   {imageUploading && (
//                     <div className="absolute inset-0 bg-black bg-opacity-50 rounded-full flex items-center justify-center">
//                       <Loader className="h-8 w-8 text-white animate-spin" />
//                     </div>
//                   )}
//                 </>
//               ) : (
//                 <div className="w-24 h-24 sm:w-32 sm:h-32 rounded-full bg-white flex items-center justify-center text-3xl sm:text-4xl font-bold text-gray-700 shadow-xl">
//                   {getInitials(user?.firstName, user?.lastName)}
//                 </div>
//               )}
//               {!saveLoading && (
//                 <label className={`absolute bottom-0 right-0 bg-white rounded-full p-1.5 sm:p-2 shadow-lg cursor-pointer hover:bg-gray-100 transition-colors ${
//                   imageUploading ? 'opacity-50 cursor-not-allowed' : ''
//                 }`}>
//                   <Camera className="w-4 h-4 sm:w-5 sm:h-5 text-gray-700" />
//                   <input
//                     type="file"
//                     className="hidden"
//                     accept="image/jpeg,image/jpg,image/png,image/webp"
//                     onChange={handleImageUpload}
//                     disabled={imageUploading}
//                   />
//                 </label>
//               )}
//             </div>
//             <h2 className="mt-3 sm:mt-4 text-xl sm:text-2xl font-bold text-white">
//               {user?.firstName} {user?.lastName}
//             </h2>
//             <p className="text-red-100 text-sm sm:text-base">{user?.email}</p>
//             <p className="text-red-100 text-xs sm:text-sm mt-1">
//               {user?.role && <span className="px-2 py-1 bg-white/20 rounded-full">{user.role}</span>}
//             </p>
//           </div>
//         </div>
//       </div>

//       {/* Content - Responsive */}
//       <div className="mx-auto px-4  lg:px-8 -mt-16 ">
//         {/* Tabs - Responsive with horizontal scroll */}
//         <div className="bg-white rounded-lg shadow-sm mb-4 sm:mb-6 px-2">
//           <div className="flex overflow-x-auto scrollbar-hide border-b">
//             {[
//               { id: 'profile', label: 'Profile', icon: User },
//               { id: 'security', label: 'Security', icon: Shield },
//               { id: 'notifications', label: 'Notifications', icon: Bell },
//               { id: 'preferences', label: 'Preferences', icon: Globe },
//             ].map((tab) => {
//               const Icon = tab.icon;
//               return (
//                 <button
//                   key={tab.id}
//                   onClick={() => setActiveTab(tab.id)}
//                   className={`flex items-center justify-center space-x-2 px-4 py-2 border-b-2 transition-colors whitespace-nowrap text-sm sm:text-base ${
//                     activeTab === tab.id
//                       ? 'bg-red-600 text-white rounded-t-lg transform -translate-y-px mt-2 gap-2'
//                       : 'text-red-600 hover:text-white hover:bg-red-700 rounded-t-lg mt-2'
//                   }`}
//                 >
//                   <Icon className="w-4 h-4" />
//                   <span className="hidden sm:inline">{tab.label}</span>
//                 </button>
//               );
//             })}
//           </div>
//         </div>

//         {/* Tab Content - Responsive */}
//         <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
//           {activeTab === 'profile' && (
//             <div className="space-y-6">
//               <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
//                 <h3 className="text-lg font-semibold">Profile Information</h3>
//                 {!isEditing ? (
//                   <button
//                     onClick={() => setIsEditing(true)}
//                     className="flex items-center justify-center space-x-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
//                   >
//                     <Edit2 className="w-4 h-4" />
//                     <span>Edit</span>
//                   </button>
//                 ) : (
//                   <div className="flex gap-2">
//                     <button
//                       onClick={handleSave}
//                       disabled={saveLoading}
//                       className="flex items-center space-x-2 px-3 sm:px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
//                     >
//                       {saveLoading ? (
//                         <Loader className="w-4 h-4 animate-spin" />
//                       ) : (
//                         <Check className="w-4 h-4" />
//                       )}
//                       <span>Save</span>
//                     </button>
//                     <button
//                       onClick={handleCancel}
//                       disabled={saveLoading}
//                       className="flex items-center space-x-2 px-3 sm:px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors disabled:opacity-50"
//                     >
//                       <X className="w-4 h-4" />
//                       <span>Cancel</span>
//                     </button>
//                   </div>
//                 )}
//               </div>

//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     First Name
//                   </label>
//                   <input
//                     type="text"
//                     value={editData.firstName || ''}
//                     onChange={(e) => setEditData({ ...editData, firstName: e.target.value })}
//                     disabled={!isEditing || saveLoading}
//                     className={`w-full px-3 sm:px-4 py-2 border rounded-lg transition-colors text-sm sm:text-base ${
//                       isEditing
//                         ? 'border-gray-300 focus:border-red-500 focus:ring-1 focus:ring-red-500'
//                         : 'border-gray-200 bg-gray-50'
//                     }`}
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Last Name
//                   </label>
//                   <input
//                     type="text"
//                     value={editData.lastName || ''}
//                     onChange={(e) => setEditData({ ...editData, lastName: e.target.value })}
//                     disabled={!isEditing || saveLoading}
//                     className={`w-full px-3 sm:px-4 py-2 border rounded-lg transition-colors text-sm sm:text-base ${
//                       isEditing
//                         ? 'border-gray-300 focus:border-red-500 focus:ring-1 focus:ring-red-500'
//                         : 'border-gray-200 bg-gray-50'
//                     }`}
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     <Mail className="inline w-4 h-4 mr-1" />
//                     Email
//                   </label>
//                   <input
//                     type="email"
//                     value={editData.email || ''}
//                     onChange={(e) => setEditData({ ...editData, email: e.target.value })}
//                     disabled={!isEditing || saveLoading}
//                     className={`w-full px-3 sm:px-4 py-2 border rounded-lg transition-colors text-sm sm:text-base ${
//                       isEditing
//                         ? 'border-gray-300 focus:border-red-500 focus:ring-1 focus:ring-red-500'
//                         : 'border-gray-200 bg-gray-50'
//                     }`}
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     <Phone className="inline w-4 h-4 mr-1" />
//                     Mobile
//                   </label>
//                   <input
//                     type="tel"
//                     value={editData.mobile || ''}
//                     onChange={(e) => setEditData({ ...editData, mobile: e.target.value })}
//                     disabled={!isEditing || saveLoading}
//                     className={`w-full px-3 sm:px-4 py-2 border rounded-lg transition-colors text-sm sm:text-base ${
//                       isEditing
//                         ? 'border-gray-300 focus:border-red-500 focus:ring-1 focus:ring-red-500'
//                         : 'border-gray-200 bg-gray-50'
//                     }`}
//                   />
//                 </div>
//               </div>

//               {/* Additional Info */}
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 pt-4 border-t">
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Department
//                   </label>
//                   <div className="px-3 sm:px-4 py-2 border border-gray-200 rounded-lg bg-gray-50">
//                     {user?.departmentName || 'Not assigned'}
//                   </div>
//                 </div>
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Division
//                   </label>
//                   <div className="px-3 sm:px-4 py-2 border border-gray-200 rounded-lg bg-gray-50">
//                     {user?.divisionName || 'Not assigned'}
//                   </div>
//                 </div>
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Member Since
//                   </label>
//                   <div className="px-3 sm:px-4 py-2 border border-gray-200 rounded-lg bg-gray-50">
//                     {user?.createdAt ? formatDateTime(user.createdAt) : 'N/A'}
//                   </div>
//                 </div>
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Status
//                   </label>
//                   <div className="px-3 sm:px-4 py-2 border border-gray-200 rounded-lg bg-gray-50">
//                     <span className={`px-2 py-1 rounded-full text-xs font-medium ${
//                       user?.isActive 
//                         ? 'bg-green-100 text-green-700' 
//                         : 'bg-red-100 text-red-700'
//                     }`}>
//                       {user?.isActive ? 'Active' : 'Inactive'}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}

//           {activeTab === 'security' && (
//             <div className="space-y-6">
//               <h3 className="text-lg font-semibold mb-4">Security Settings</h3>
//               <div className="space-y-4">
//                 <button className="w-full sm:w-auto px-4 sm:px-6 py-2 sm:py-3 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-sm sm:text-base">
//                   Change Password
//                 </button>
//                 <div className="p-4 bg-gray-50 rounded-lg">
//                   <p className="text-sm text-gray-600">
//                     Last password change: Never
//                   </p>
//                 </div>
//               </div>
//             </div>
//           )}

//           {activeTab === 'notifications' && (
//             <div className="space-y-6">
//               <h3 className="text-lg font-semibold mb-4">Notification Preferences</h3>
//               <div className="space-y-4">
//                 {[
//                   { name: 'Email Notifications', enabled: true },
//                   { name: 'SMS Notifications', enabled: false },
//                   { name: 'Push Notifications', enabled: true }
//                 ].map((item) => (
//                   <label key={item.name} className="flex items-center justify-between p-3 sm:p-4 bg-gray-50 rounded-lg cursor-pointer hover:bg-gray-100 transition-colors">
//                     <span className="font-medium text-sm sm:text-base">{item.name}</span>
//                     <input 
//                       type="checkbox" 
//                       defaultChecked={item.enabled}
//                       className="w-4 h-4 sm:w-5 sm:h-5 text-red-600 rounded focus:ring-red-500" 
//                     />
//                   </label>
//                 ))}
//               </div>
//             </div>
//           )}

//           {activeTab === 'preferences' && (
//             <div className="space-y-6">
//               <h3 className="text-lg font-semibold mb-4">Preferences</h3>
//               <div className="space-y-4">
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Language
//                   </label>
//                   <select className="w-full px-3 sm:px-4 py-2 border border-gray-300 rounded-lg focus:border-red-500 focus:ring-1 focus:ring-red-500 text-sm sm:text-base">
//                     <option>English</option>
//                     <option>Spanish</option>
//                     <option>French</option>
//                   </select>
//                 </div>
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Timezone
//                   </label>
//                   <select className="w-full px-3 sm:px-4 py-2 border border-gray-300 rounded-lg focus:border-red-500 focus:ring-1 focus:ring-red-500 text-sm sm:text-base">
//                     <option>Asia/Kolkata</option>
//                     <option>America/New_York</option>
//                     <option>Europe/London</option>
//                   </select>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Add scrollbar hide styles */}
//       <style >{`
//         .scrollbar-hide {
//           -ms-overflow-style: none;
//           scrollbar-width: none;
//         }
//         .scrollbar-hide::-webkit-scrollbar {
//           display: none;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default MyAccount;



// pages/MyAccount.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  ArrowLeft, 
  Camera, 
  Mail, 
  Phone, 
  User, 
  Shield, 
  Bell, 
  Globe,
  Edit2,
  Loader,
  Check,
  X
} from 'lucide-react';
import api from '../common/apiClient';
import SummaryApi from '../common/SummaryApi';
import { formatDateTime } from '../helpers/formatDateTime';
import { toast } from 'react-toastify';
import { MyAccountSkeleton } from '../components/SkeletonComponents/MyAccountSkeleton';
import { useSelector, useDispatch } from 'react-redux';
import { setUserDetails } from '../store/userSlice'; // You'll need to create this action

const MyAccount = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state?.user?.user);
  const loading = useSelector((state) => state?.user?.loading || false);
  
  const [isEditing, setIsEditing] = useState(false);
  const [editData, setEditData] = useState(user || {});
  const [activeTab, setActiveTab] = useState('profile');
  const [imageUploading, setImageUploading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const navigate = useNavigate();

  // Get userId from Redux state
  const userId = user?._id;

  const handleImageUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // Validate file type
    const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
    if (!validTypes.includes(file.type)) {
      toast.error('Please upload a valid image file (JPG, PNG, or WebP)');
      e.target.value = '';
      return;
    }

    // Validate file size (5MB max)
    if (file.size > 5 * 1024 * 1024) {
      toast.error('Image size should be less than 5MB');
      e.target.value = '';
      return;
    }

    setImageUploading(true);
    const formData = new FormData();
    formData.append('profilePicture', file);

    try {
      const response = await api.put(SummaryApi.uploadUserPicture.url(userId), formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.data.success) {
        toast.success('Profile picture updated successfully');
        
        // Update user data with new picture
        const updatedUser = response.data.user || {
          ...user,
          profilePicture: response.data.profilePicture
        };
        
        // Update Redux state
        dispatch(setUserDetails({...user, profilePicture: updatedUser.profilePicture}));
        setEditData(updatedUser);
        
        // Update localStorage
        // const localUser = JSON.parse(localStorage.getItem('user') || '{}');
        // localStorage.setItem('user', JSON.stringify({
        //   ...localUser,
        //   profilePicture: updatedUser.profilePicture
        // }));
      }
    } catch (error) {
      console.error("Error uploading profile picture:", error);
      toast.error(error.response?.data?.message || 'Failed to upload image');
    } finally {
      setImageUploading(false);
      e.target.value = '';
    }
  };

  const handleSave = async () => {
    setSaveLoading(true);
    try {
      const response = await api.put(SummaryApi.updateUser.url(userId), {
        firstName: editData.firstName,
        lastName: editData.lastName,
        email: editData.email,
        mobile: editData.mobile
      });

      if (response.data.success) {
        const updatedUser = response.data.data || response.data.user;
        
        // Update Redux state
        dispatch(setUserDetails({...user, ...updatedUser}));
        setEditData(updatedUser);
        setIsEditing(false);
        toast.success('Profile updated successfully');
        
        // Update localStorage
        const localUser = JSON.parse(localStorage.getItem('user') || '{}');
        localStorage.setItem('user', JSON.stringify({
          ...localUser,
          ...updatedUser
        }));
      }
    } catch (error) {
      console.error("Error updating profile:", error);
      toast.error(error.response?.data?.message || 'Failed to update profile');
    } finally {
      setSaveLoading(false);
    }
  };

  const handleCancel = () => {
    setIsEditing(false);
    setEditData(user);
  };

  const getInitials = (firstName, lastName) => {
    if (!firstName && !lastName) return 'U';
    return `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase();
  };

  if (loading) {
    return <MyAccountSkeleton />;
  }

  if (!user) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <p className="text-gray-600 mb-4">No user data available</p>
          <button
            onClick={() => navigate('/login')}
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
          >
            Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="">
      {/* Header - Responsive */}
      <div className="bg-white shadow-sm border-b sticky top-0 z-10">
        <div className="mx-auto px-4">
          <div className="flex items-center justify-between h-12">
            <div className="flex items-center">
              <button
                onClick={() => navigate(-1)}
                className="mr-2 sm:mr-4 p-2 hover:bg-gray-100 rounded-lg transition-colors"
              >
                <ArrowLeft className="w-5 h-5" />
              </button>
              <h1 className="text-lg sm:text-xl font-semibold">My Account</h1>
            </div>
          </div>
        </div>
      </div>

      {/* Profile Header - Responsive */}
      <div className="bg-gradient-to-r from-red-600 to-red-600 pt-6 sm:pt-8 pb-24 sm:pb-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <div className="relative inline-block">
              {user?.profilePicture ? (
                <>
                  <img
                    src={user.profilePicture}
                    alt={`${user.firstName} ${user.lastName}`}
                    className="w-24 h-24 sm:w-32 sm:h-32 rounded-full object-cover border-4 border-white shadow-xl"
                  />
                  {imageUploading && (
                    <div className="absolute inset-0 bg-black bg-opacity-50 rounded-full flex items-center justify-center">
                      <Loader className="h-8 w-8 text-white animate-spin" />
                    </div>
                  )}
                </>
              ) : (
                <div className="w-24 h-24 sm:w-32 sm:h-32 rounded-full bg-white flex items-center justify-center text-3xl sm:text-4xl font-bold text-gray-700 shadow-xl">
                  {getInitials(user?.firstName, user?.lastName)}
                </div>
              )}
              {!saveLoading && (
                <label className={`absolute bottom-0 right-0 bg-white rounded-full p-1.5 sm:p-2 shadow-lg cursor-pointer hover:bg-gray-100 transition-colors ${
                  imageUploading ? 'opacity-50 cursor-not-allowed' : ''
                }`}>
                  <Camera className="w-4 h-4 sm:w-5 sm:h-5 text-gray-700" />
                  <input
                    type="file"
                    className="hidden"
                    accept="image/jpeg,image/jpg,image/png,image/webp"
                    onChange={handleImageUpload}
                    disabled={imageUploading}
                  />
                </label>
              )}
            </div>
            <h2 className="mt-3 sm:mt-4 text-xl sm:text-2xl font-bold text-white">
              {user?.firstName} {user?.lastName}
            </h2>
            <p className="text-red-100 text-sm sm:text-base">{user?.email}</p>
            <p className="text-red-100 text-xs sm:text-sm mt-1">
              {user?.role && <span className="px-2 py-1 bg-white/20 rounded-full">{user.role}</span>}
            </p>
          </div>
        </div>
      </div>

      {/* Content - Responsive */}
      <div className="mx-auto px-4 lg:px-8 -mt-16">
        {/* Tabs - Responsive with horizontal scroll */}
        <div className="bg-white rounded-lg shadow-sm mb-4 sm:mb-6 px-2">
          <div className="flex overflow-x-auto scrollbar-hide border-b">
            {[
              { id: 'profile', label: 'Profile', icon: User },
              { id: 'security', label: 'Security', icon: Shield },
              { id: 'notifications', label: 'Notifications', icon: Bell },
              { id: 'preferences', label: 'Preferences', icon: Globe },
            ].map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center justify-center space-x-2 px-4 py-2 border-b-2 transition-colors whitespace-nowrap text-sm sm:text-base ${
                    activeTab === tab.id
                      ? 'bg-red-600 text-white rounded-t-lg transform -translate-y-px mt-2 gap-2'
                      : 'text-red-600 hover:text-white hover:bg-red-700 rounded-t-lg mt-2'
                  }`}
                >
                  <Icon className="w-4 h-4" />
                  <span className="hidden sm:inline">{tab.label}</span>
                </button>
              );
            })}
          </div>
        </div>

        {/* Tab Content - Responsive */}
        <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6">
          {activeTab === 'profile' && (
            <div className="space-y-6">
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
                <h3 className="text-lg font-semibold">Profile Information</h3>
                {!isEditing ? (
                  <button
                    onClick={() => setIsEditing(true)}
                    className="flex items-center justify-center space-x-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
                  >
                    <Edit2 className="w-4 h-4" />
                    <span>Edit</span>
                  </button>
                ) : (
                  <div className="flex gap-2">
                    <button
                      onClick={handleSave}
                      disabled={saveLoading}
                      className="flex items-center space-x-2 px-3 sm:px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      {saveLoading ? (
                        <Loader className="w-4 h-4 animate-spin" />
                      ) : (
                        <Check className="w-4 h-4" />
                      )}
                      <span>Save</span>
                    </button>
                    <button
                      onClick={handleCancel}
                      disabled={saveLoading}
                      className="flex items-center space-x-2 px-3 sm:px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors disabled:opacity-50"
                    >
                      <X className="w-4 h-4" />
                      <span>Cancel</span>
                    </button>
                  </div>
                )}
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    First Name
                  </label>
                  <input
                    type="text"
                    value={editData.firstName || ''}
                    onChange={(e) => setEditData({ ...editData, firstName: e.target.value })}
                    disabled={!isEditing || saveLoading}
                    className={`w-full px-3 sm:px-4 py-2 border rounded-lg transition-colors text-sm sm:text-base ${
                      isEditing
                        ? 'border-gray-300 focus:border-red-500 focus:ring-1 focus:ring-red-500'
                        : 'border-gray-200 bg-gray-50'
                    }`}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Last Name
                  </label>
                  <input
                    type="text"
                    value={editData.lastName || ''}
                    onChange={(e) => setEditData({ ...editData, lastName: e.target.value })}
                    disabled={!isEditing || saveLoading}
                    className={`w-full px-3 sm:px-4 py-2 border rounded-lg transition-colors text-sm sm:text-base ${
                      isEditing
                        ? 'border-gray-300 focus:border-red-500 focus:ring-1 focus:ring-red-500'
                        : 'border-gray-200 bg-gray-50'
                    }`}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    <Mail className="inline w-4 h-4 mr-1" />
                    Email
                  </label>
                  <input
                    type="email"
                    value={editData.email || ''}
                    onChange={(e) => setEditData({ ...editData, email: e.target.value })}
                    disabled={!isEditing || saveLoading}
                    className={`w-full px-3 sm:px-4 py-2 border rounded-lg transition-colors text-sm sm:text-base ${
                      isEditing
                        ? 'border-gray-300 focus:border-red-500 focus:ring-1 focus:ring-red-500'
                        : 'border-gray-200 bg-gray-50'
                    }`}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    <Phone className="inline w-4 h-4 mr-1" />
                    Mobile
                  </label>
                  <input
                    type="tel"
                    value={editData.mobile || ''}
                    onChange={(e) => setEditData({ ...editData, mobile: e.target.value })}
                    disabled={!isEditing || saveLoading}
                    className={`w-full px-3 sm:px-4 py-2 border rounded-lg transition-colors text-sm sm:text-base ${
                      isEditing
                        ? 'border-gray-300 focus:border-red-500 focus:ring-1 focus:ring-red-500'
                        : 'border-gray-200 bg-gray-50'
                    }`}
                  />
                </div>
              </div>

              {/* Additional Info */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 pt-4 border-t">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Department
                  </label>
                  <div className="px-3 sm:px-4 py-2 border border-gray-200 rounded-lg bg-gray-50">
                    {user?.departmentName || 'Not assigned'}
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Division
                  </label>
                  <div className="px-3 sm:px-4 py-2 border border-gray-200 rounded-lg bg-gray-50">
                    {user?.divisionName || 'Not assigned'}
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Member Since
                  </label>
                  <div className="px-3 sm:px-4 py-2 border border-gray-200 rounded-lg bg-gray-50">
                    {user?.createdAt ? formatDateTime(user.createdAt) : 'N/A'}
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Status
                  </label>
                  <div className="px-3 sm:px-4 py-2 border border-gray-200 rounded-lg bg-gray-50">
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                      user?.isActive 
                        ? 'bg-green-100 text-green-700' 
                        : 'bg-red-100 text-red-700'
                    }`}>
                      {user?.isActive ? 'Active' : 'Inactive'}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'security' && (
            <div className="space-y-6">
              <h3 className="text-lg font-semibold mb-4">Security Settings</h3>
              <div className="space-y-4">
                <button className="w-full sm:w-auto px-4 sm:px-6 py-2 sm:py-3 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-sm sm:text-base">
                  Change Password
                </button>
                <div className="p-4 bg-gray-50 rounded-lg">
                  <p className="text-sm text-gray-600">
                    Last password change: Never
                  </p>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'notifications' && (
            <div className="space-y-6">
              <h3 className="text-lg font-semibold mb-4">Notification Preferences</h3>
              <div className="space-y-4">
                {[
                  { name: 'Email Notifications', enabled: true },
                  { name: 'SMS Notifications', enabled: false },
                  { name: 'Push Notifications', enabled: true }
                ].map((item) => (
                  <label key={item.name} className="flex items-center justify-between p-3 sm:p-4 bg-gray-50 rounded-lg cursor-pointer hover:bg-gray-100 transition-colors">
                    <span className="font-medium text-sm sm:text-base">{item.name}</span>
                    <input 
                      type="checkbox" 
                      defaultChecked={item.enabled}
                      className="w-4 h-4 sm:w-5 sm:h-5 text-red-600 rounded focus:ring-red-500" 
                    />
                  </label>
                ))}
              </div>
            </div>
          )}

          {activeTab === 'preferences' && (
            <div className="space-y-6">
              <h3 className="text-lg font-semibold mb-4">Preferences</h3>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Language
                  </label>
                  <select className="w-full px-3 sm:px-4 py-2 border border-gray-300 rounded-lg focus:border-red-500 focus:ring-1 focus:ring-red-500 text-sm sm:text-base">
                    <option>English</option>
                    <option>Spanish</option>
                    <option>French</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Timezone
                  </label>
                  <select className="w-full px-3 sm:px-4 py-2 border border-gray-300 rounded-lg focus:border-red-500 focus:ring-1 focus:ring-red-500 text-sm sm:text-base">
                    <option>Asia/Kolkata</option>
                    <option>America/New_York</option>
                    <option>Europe/London</option>
                  </select>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Add scrollbar hide styles */}
      <style >{`
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </div>
  );
};

export default MyAccount;